<div class="{{isActivity == true ? 'col d-flex align-items-center gap-1':'row'}}">
  <div class="{{isActivity == true ? 'col-sm-12':'p-0  col-6 col-md-6 col-lg-10 col-xl-10 col-xxl-10'}}">
    <div class="wrapper position-relative {{isActivity == true ? 'wrapper-2':''}}">
      <input #flatpickrInput type="text" class="flatpick" placeholder=" ">
      <span class="calendar-icon" (click)="openDatepicker()">
        <img src="../../../../assets/SVGIcons/calendar.svg" alt="">
      </span>
    </div>
  </div>
  <div class="col-2" *ngIf="clearSelectedDate">
    <!-- <div> -->
      <img class="crossIcon" width="15px"
        height="15px" src="./assets/SVGIcons/crossCircleIcon.svg" alt="" (click)="clearSelected_Date()">
      <!-- <app-svg-icon  [src]="'./assets/SVGIcons/crossCircleIcon.svg'"></app-svg-icon> -->
    <!-- </div> -->
  </div>
</div>